module.exports = __webpack_public_path__ + "img/loto-4-59-luckia.b37204b9.png";